
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/external-experts/grok",
      function () {
        return require("private-next-pages/docs/external-experts/grok.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/external-experts/grok"])
      });
    }
  